import FunnelStepSelect from '@/Components/Funnel/FunnelStepSelect.vue'
import FunnelStepContact from '@/Components/Funnel/FunnelStepContact.vue'
import statesOfGermany from '../../json/statesOfGermany.json'
import Household from '@/Components/Stairlift/Steps/Household.vue'
import StateStep from '@/Components/Stairlift/Steps/StateStep.vue'
import Estimation from '@/Components/Stairlift/Steps/Estimation.vue'
import Success from '@/Components/Stairlift/Steps/Success.vue'
import Result from '@/Components/Stairlift/Steps/Result.vue'
import StairsWidth from '@/Components/Stairlift/Steps/StairsWidthStep.vue'

export function useStairliftFunnel() {
    const funnel = {
        routeName: 'stairlift.funnel.step',
        tagEvents: {
            contact: 'stairlift_contact_form_submitted',
        },
    }

    const groups = [
        {
            id: 1,
            key: 'lift_type',
            label: 'Liftart',
        },
        {
            id: 2,
            key: 'finance',
            label: 'Finanzierung & Zuschüsse',
        },
        {
            id: 3,
            key: 'recommendation',
            label: 'Herstellerempfehlung',
        },
    ]

    const steps = [
        // {
        //     id: "orderer",
        //     key: "orderer",
        //     group: 1,
        //     type: "select",
        //     component: FunnelStepSelect,
        //     formField: "orderer",
        //     title: {
        //         direct: "Suchen Sie für sich oder ein Familienmitglied?",
        //         indirect: "Suchen Sie für sich oder ein Familienmitglied?",
        //     },
        //     options: [
        //         {
        //             key: "direct",
        //             label: "Für mich",
        //             img: "/img/icons/direct.png",
        //         },
        //         {
        //             key: "indirect",
        //             label: "Für ein Familienmitglied",
        //             img: "/img/icons/indirect.png",
        //         },
        //     ],
        //     next: () => "stairlift_type",
        // },

        // ----- Lift Section ------------
        {
            id: 'stairlift_type',
            key: 'stairlift_type',
            type: 'select',
            group: 1,
            component: FunnelStepSelect,
            formField: 'stairlift_type',
            title: {
                direct: 'Was für einen Lift suchen Sie?',
                indirect: 'Was für ein Lift wird benötigt?',
            },
            options: [
                {
                    key: 'seated_lift',
                    label: 'Sitzlift',
                    img: '/img/icons/sitzlift.png',
                },
                {
                    key: 'platform_lift',
                    label: 'Plattformlift',
                    img: '/img/icons/plattform.png',
                },
                {
                    key: 'hub_lift',
                    label: 'Hublift',
                    img: '/img/icons/lift.png',
                },
                {
                    key: 'unknown',
                    label: 'Weiß nicht',
                    img: '/img/icons/unknown.png',
                },
            ],
            next: () => 'stairlift_location',
        },
        {
            id: 'stairlift_location',
            key: 'stairlift_location',
            type: 'select',
            group: 1,
            component: FunnelStepSelect,
            formField: 'stairlift_location',
            title: {
                direct: 'Wo soll der Lift installiert werden?',
                indirect: 'Wo soll der Lift installiert werden?',
            },
            options: [
                {
                    key: 'indoors',
                    label: 'Innen',
                    img: '/img/icons/inside.png',
                },
                {
                    key: 'outdoors',
                    label: 'Außen',
                    img: '/img/icons/outside.png',
                },
                {
                    key: 'indoors_outdoors',
                    label: 'Innen und Außen',
                    img: '/img/icons/both.png',
                },
                {
                    key: 'unknown',
                    label: 'Weiß nicht',
                    img: '/img/icons/unknown.png',
                },
            ],
            next: () => 'stairlift_form',
        },
        {
            id: 'stairlift_form',
            key: 'stairlift_form',
            type: 'select',
            group: 1,
            component: FunnelStepSelect,
            formField: 'stairlift_form',
            title: {
                direct: 'Welche Form hat Ihre Treppe?',
                indirect: 'Welche Form hat die Treppe?',
            },
            options: [
                {
                    key: 'straight',
                    label: 'Gerade',
                    img: '/img/icons/straight.png',
                },
                {
                    key: 'curved',
                    label: 'Kurvige',
                    img: '/img/icons/curvy.png',
                },
                {
                    key: 'curved_podium',
                    label: 'L-Form mit Podest',
                    img: '/img/icons/podium.png',
                },
                {
                    key: 'other',
                    label: 'Andere Form',
                    img: '/img/icons/other.png',
                },
            ],
            next: () => 'stairlift_floor',
        },
        {
            id: 'stairlift_floor',
            key: 'stairlift_floor',
            type: 'select',
            group: 1,
            component: FunnelStepSelect,
            formField: 'stairlift_floor',
            title: {
                direct: 'Über wie viele Etagen soll der Lift gehen?',
                indirect: 'Über wie viele Etagen soll der Lift gehen?',
            },
            options: [
                {
                    key: '1_floor',
                    label: 'Eine Etage',
                    img: '/img/icons/1-etage.png',
                },
                {
                    key: '2_floor',
                    label: 'Zwei Etagen',
                    img: '/img/icons/2-etage.png',
                },
                {
                    key: '2_plus_floor',
                    label: 'Mehr als zwei Etagen',
                    img: '/img/icons/2-plus-etage.png',
                },
                {
                    key: 'unknown',
                    label: 'Weiß nicht',
                    img: '/img/icons/unknown.png',
                },
            ],
            next: () => 'accident_dependent',
        },

        // ----- Accident Section ------------
        {
            id: 'accident_dependent',
            key: 'accident_dependent',
            type: 'select',
            group: 2,
            component: FunnelStepSelect,
            formField: 'accident_dependent',
            title: {
                direct: 'Sind Sie aufgrund eines Unfalls auf den Lift angewiesen?',
                indirect: 'Sind Sie aufgrund eines Unfalls auf den Lift angewiesen?',
            },
            options: [
                {
                    key: 'yes',
                    label: 'Ja',
                    img: '/img/icons/injury.png',
                },
                {
                    key: 'no',
                    label: 'Nein',
                    img: '/img/icons/injury-not.png',
                },
            ],
            next: (form) => {
                if (form.accident_dependent === 'yes') {
                    return 'accident_cause'
                } else {
                    return 'social_care'
                }
            },
        },
        {
            id: 'accident_cause',
            key: 'accident_cause',
            type: 'select',
            group: 2,
            component: FunnelStepSelect,
            formField: 'accident_cause',
            title: {
                direct: 'Wie wurde der Unfall verursacht?',
                indirect: 'Wie wurde der Unfall verursacht?',
            },
            options: [
                {
                    key: 'work_accident',
                    label: 'Arbeitsunfall',
                    img: '/img/icons/work-injury.png',
                },
                {
                    key: 'accident_with_fault',
                    label: 'Unfall mit Fremdverschulden',
                    img: '/img/icons/external-cause.png',
                },
                {
                    key: 'other',
                    label: 'Sonstige Gründe',
                    img: '/img/icons/unknown.png',
                },
            ],
            next: () => 'estimation',
        },
        {
            id: 'social_care',
            key: 'social_care',
            type: 'select',
            group: 2,
            component: FunnelStepSelect,
            formField: 'social_care',
            title: {
                direct: 'Empfangen Sie Sozialhilfe?',
                indirect: 'Empfangen Sie Sozialhilfe?',
            },
            options: [
                {
                    key: 'yes',
                    label: 'Ja',
                    img: '/img/icons/social.png',
                },
                {
                    key: 'no',
                    label: 'Nein',
                    img: '/img/icons/social-not.png',
                },
            ],
            next: (form) => {
                if (form.social_care === 'yes') {
                    return 'estimation'
                } else {
                    return 'care_dependent_people'
                }
            },
        },

        // ----- Person Section ------------

        {
            id: 'care_dependent_people',
            key: 'care_dependent_people',
            type: 'select',
            group: 2,
            component: Household,
            formField: 'care_dependent_people',
            title: {
                self: 'Bitte geben Sie an, wie viele Personen im Ihrem Haushalt leben und ob diese pflegebedürftig sind.',
                family: 'Bitte geben Sie an, wie viele Personen im Haushalt sind und ob diese pflegebedürftig sind',
            },
            careText: 'Pflegegrad der Person',
            next: () => 'state',
        },

        {
            id: 'state',
            key: 'state',
            type: 'select',
            group: 2,
            component: StateStep,
            formField: 'state',
            title: {
                direct: 'In welchem Bundesland leben Sie?',
                indirect: 'In welchem Bundesland soll die Treppe installiert werden?',
            },
            description:
                'Es gibt länderspezifische Förderungen und Zuschüsse. Mit der Angabe des Bundeslandes können wir Ihnen regionale Hersteller und Förderungen heraussuchen.',
            img: '/img/icons/unknown.png',
            options: statesOfGermany,
            next: () => 'estimation',
        },

        {
            id: 'estimation',
            key: 'estimation',
            type: 'custom',
            group: 2,
            component: Estimation,
            title: {
                direct: 'Erste Einschätzung - Wie sehen die Kosten aus',
                indirect: 'Erste Einschätzung - Wie sehen die Kosten aus?',
            },
            next: () => 'first_consultation',
        },

        {
            id: 'first_consultation',
            key: 'first_consultation',
            type: 'select',
            group: 3,
            component: FunnelStepSelect,
            formField: 'first_consultation',
            title: {
                direct: 'Jetzt brauchen Sie nur noch den passenden Hersteller. ',
                indirect: 'Jetzt brauchen Sie nur noch den passenden Hersteller. ',
            },
            options: [
                {
                    key: 'expert',
                    label: 'Mit einem Mobilitätsexperten direkt sprechen und gemeinsam den passenden Hersteller finden.',
                    img: '/img/icons/mimovo.png',
                },
                {
                    key: 'provider',
                    label: 'Fragen beantworten und passende Hersteller empfohlen bekommen.',
                    img: '/img/icons/supplier.png',
                },
            ],
            next: (form) => {
                if (form.first_consultation === 'expert') {
                    return 'contact-short'
                } else {
                    return 'house_type'
                }
            },
        },
        {
            id: 'house_type',
            key: 'house_type',
            type: 'select',
            group: 3,
            component: FunnelStepSelect,
            formField: 'house_type',
            title: {
                direct: 'Wohnen Sie in einem Einfamilien- oder Mehrfamilienhaus? ',
                indirect: 'Wird der Lift in einem Einfamilienhaus oder Mehrfamilienhaus benötigt?',
            },
            options: [
                {
                    key: 'house',
                    label: 'Einfamilienhaus',
                    img: '/img/icons/einfamilienhaus.png',
                },
                {
                    key: 'apartment',
                    label: 'Mehrfamilienhaus',
                    img: '/img/icons/mehrfamilienhaus.png',
                },
            ],
            next: () => 'housing_status',
        },
        {
            id: 'housing_status',
            key: 'housing_status',
            type: 'select',
            group: 3,
            component: FunnelStepSelect,
            formField: 'housing_status',
            title: {
                direct: 'Wohnen Sie zur Miete oder im Eigentum? ',
                indirect: 'Handelt es sich um Eigentum oder Miete?',
            },
            options: [
                {
                    key: 'owner',
                    label: 'Eigentum',
                    img: '/img/icons/property.png',
                },
                {
                    key: 'tenant',
                    label: 'Mieter',
                    img: '/img/icons/lease.png',
                },
            ],
            next: () => 'lift_needed_by',
        },
        {
            id: 'lift_needed_by',
            key: 'lift_needed_by',
            type: 'select',
            group: 3,
            component: FunnelStepSelect,
            formField: 'lift_needed_by',
            title: {
                direct: 'Zu wann benötigen Sie den Lift? ',
                indirect: 'Zu wann wird der Lift benötigt?',
            },
            options: [
                {
                    key: 'now',
                    label: 'Am liebsten heute',
                    img: '/img/icons/asap.png',
                },
                {
                    key: '1_to_3_months',
                    label: 'Zeitnah, in 1-3 Monaten',
                    img: '/img/icons/soon.png',
                },
                {
                    key: '6_months',
                    label: 'In den nächsten 6 Monaten',
                    img: '/img/icons/eventually.png',
                },
                {
                    key: 'unknown',
                    label: 'Ich weiß es noch nicht',
                    img: '/img/icons/unknown.png',
                },
            ],
            next: () => 'stair_width',
        },
        {
            id: 'stair_width',
            key: 'stair_width',
            group: 3,
            type: 'custom',
            component: StairsWidth,
            title: {
                direct: 'Wie breit ist Ihre Treppe?',
                indirect: 'Wie breit ist die Treppe?',
            },
            next: () => 'contact-long',
        },
        // ---------------- SUCCESS ----------------
        {
            id: 'result-short',
            key: 'result',
            group: 3,
            type: 'custom',
            component: Result,
            text: 'Vielen Dank für Ihre Angaben. Jetzt können Sie ein kostenloses Beratungsgespräch vereinbaren, bei dem ein Leben-ohne-Grenzen-Experte Ihnen helfen wird, den passenden Treppenlift-Anbieter in Ihrer Nähe zu finden.',
            checkTextList: [
                'Verlässliche und professionelle Beratung',
                'Treppenlift geeignet für eine Förderung',
                'Hilfe beim Förderantrag',
            ],
            next: () => 'contact-short',
        },
        {
            id: 'result-long',
            key: 'result',
            group: 3,
            type: 'custom',
            component: Result,
            text: 'Vielen Dank für Ihre Angaben. Wir haben bereits den passenden Treppenlift-Anbieter für Sie gefunden. Vereinbaren Sie jetzt ein kostenloses Erstgespräch mit unseren Experten, um das Ergebnis zu besprechen und alle offenen Fragen zu klären.',
            checkTextList: [
                'Verlässliche und professionelle Beratung',
                'Treppenlift geeignet für eine Förderung',
                'Hilfe beim Förderantrag',
            ],
            next: () => 'contact-long',
        },
        {
            id: 'contact-short',
            key: 'contact',
            group: 3,
            type: 'custom',
            component: FunnelStepContact,
            titleText:
                'Vielen Dank für Ihre Angaben. Jetzt können Sie ein kostenloses Beratungsgespräch vereinbaren, bei dem ein Leben-ohne-Grenzen-Experte Ihnen helfen wird, den passenden Treppenlift-Anbieter in Ihrer Nähe zu finden.',
            text: 'Jetzt kostenloses Beratungsgespräch vereinbaren und ein Leben-ohne-Grenzen-Experte findet mit ihnen gemeinsam den passenden Treppenlift-Anbieter in ihrer Nähe.',
            next: () => 'success',
        },
        {
            id: 'contact-long',
            key: 'contact',
            group: 3,
            type: 'custom',
            component: FunnelStepContact,
            titleText:
                'Vielen Dank für Ihre Angaben. Jetzt können Sie ein kostenloses Beratungsgespräch vereinbaren, bei dem ein Leben-ohne-Grenzen-Experte Ihnen helfen wird, den passenden Treppenlift-Anbieter in Ihrer Nähe zu finden.',
            text: 'Vereinbaren Sie jetzt ein kostenloses Erstgespräch mit unseren Experten, um das Ergebnis zu erhalten und alle ihre offenen Fragen zu klären.',
            next: () => 'success',
        },
        {
            id: 'success',
            key: 'success',
            group: 6,
            type: 'custom',
            component: Success,
        },
    ]

    return {
        funnel,
        steps,
        groups,
    }
}
